// Identity is shared by barcode, SKU and manual selection. Variants stay separate.
export function counterSaleLineKey(item) {
  return `${item.productId || ""}:${item.variantId || ""}`;
}

export function addCounterSaleItem(items, selection) {
  const key = counterSaleLineKey(selection);
  const existing = items.findIndex((item) => item.productId && counterSaleLineKey(item) === key);
  if (existing >= 0) {
    return items.map((item, index) => index === existing
      ? { ...item, quantity: String((Number(item.quantity) || 0) + 1) }
      : item);
  }
  return [...items.filter((item) => item.productId || String(item.name || "").trim()), selection];
}

export function changeCounterSaleVariant(items, index, patch) {
  const selected = { ...items[index], ...patch };
  const key = counterSaleLineKey(selected);
  const existing = items.findIndex((item, itemIndex) => itemIndex !== index && counterSaleLineKey(item) === key);
  if (existing < 0) return items.map((item, itemIndex) => itemIndex === index ? selected : item);
  return items.flatMap((item, itemIndex) => {
    if (itemIndex === index) return [];
    return [itemIndex === existing
      ? { ...item, quantity: String((Number(item.quantity) || 0) + (Number(selected.quantity) || 0)) }
      : item];
  });
}

export function counterQuantity(value) {
  const text = String(value ?? "").trim().replace(",", ".");
  if (!/^(?:\d+(?:\.\d*)?|\.\d+)$/.test(text)) return null;
  const number = Number(text);
  return Number.isFinite(number) && number > 0 ? number : null;
}

export function isCounterScannerBurst(burst, now) {
  const averageGap = (burst.lastAt - burst.firstAt) / Math.max(1, burst.text.length - 1);
  return burst.text.length >= 4 && averageGap <= 50 && burst.maxGap <= 150 && now - burst.lastAt <= 200;
}
